<!--
  Forbrukerrådet - Kommunetesten
  @link https://gitlab01.copyleft.no/FBR/kommunetesten-new
  @author Anders Evenrud <anders.evenrud@copyleft.no>
-->

<template>
  <div class="heading">
    <slot />
    <span v-if="year"> {{ year }}</span>
  </div>
</template>

<style lang="scss" scoped>
@import "../assets/variables";

.heading {
  font-size: 130%;
  font-weight: bold;
  margin-top: 0.5em;
  margin-bottom: 1em;
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: normal;

  & > span {
    padding-left: 0.2em;
  }
}
</style>

<script>
export default {
  props: {
    year: Number
  }
}
</script>
